/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import UserService from "../../service/user-service.js";
import RoleService from "../../service/role-service.js";

const userService = new UserService();
const roleService = new RoleService();

await loadDictionary('user-create-user-window');

function CreateUserWindow({isOpenWindow, onCloseWindow}) {
  const [roleId, setRoleId] = useState();
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const [roles, setRoles] = useState([]);
    
  const handleClose = () => {
    setRoleId();
    setName('');
    setMobile('');

    onCloseWindow();
  };
  
  const handleSubmit = () => {
    const user = {
      role_id: parseInt(roleId),
      name: name,
      mobile: mobile,
    };

    userService.create(user).then(result => {
      if(result) {
        handleClose();
      }
    }).catch(error => {
      console.error(error);
    });
  };

  useEffect(() => {
    if (isOpenWindow) {
      roleService.findAll().then(setRoles);
    }
  }, [isOpenWindow]);

  return (
    <Modal show={isOpenWindow} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>{i18n.t("user-create-user-window.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form method="POST" id="CreateForm" onSubmit={e => {e.preventDefault(); handleSubmit()}}>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("user-create-user-window.name")}</Form.Label>
              <Form.Control type="text" value={name} onChange={e => {setName(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("user-create-user-window.mobile")}</Form.Label>
              <Form.Control type="text" dir="ltr" value={mobile} onChange={e => {setMobile(e.target.value)}}></Form.Control>
            </Form.Group>
          </div>
          <div className="row">
            <Form.Group className="mb-3 col" controlId="">
              <Form.Label>{i18n.t("user-create-user-window.role")}</Form.Label>
              <Form.Select value={roleId} onChange={e => {setRoleId(e.target.value)}}>
                {roles.map(role => <option key={role.id} value={role.id}>{role.name}</option>)}
              </Form.Select>
            </Form.Group>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>{i18n.t("user-create-user-window.cancel_button")}</Button>
        <Button variant="primary" type="submit" form="CreateForm" >{i18n.t("user-create-user-window.create_button")}</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateUserWindow;